import { AppBar, Box, Container, CssBaseline, ThemeProvider, Toolbar, createTheme, styled } from '@mui/material';
import { ReactNode } from 'react';
import { lanscoPalette, lanscoTypography } from '../lansco-theme';

interface LayoutProps {
  children: ReactNode;
}

// Define theme
const theme = createTheme({
  palette: lanscoPalette,
  typography: lanscoTypography,
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 0,
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
  },
});

// Create header component
const Header = styled(AppBar)({
  backgroundColor: '#fff',
  boxShadow: 'none',
  border: 'none',
  position: 'relative',
});

const LogoImage = styled('img')({
  height: 30,
  margin: '10px 0',
});

export const Layout = ({ children }: LayoutProps) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ backgroundColor: '#2d2d2d', minHeight: '100vh' }}>
        <Header position="static">
          <Toolbar sx={{ justifyContent: 'flex-start' }}>
            <LogoImage src="/logo.png" alt="Lansco Logo" />
          </Toolbar>
        </Header>
        <Container maxWidth="md" sx={{ pb: 0 }}>
          {children}
        </Container>
      </Box>
    </ThemeProvider>
  );
};